import { Dropdown } from "react-bootstrap";
import { useLanguage } from "../context/LanguageContext";
import { motion } from "framer-motion";

export const LanguageDropdown = () => {
    const { lang, setLang } = useLanguage();

    return (
        <Dropdown align="end">
            <Dropdown.Toggle
                as={motion.button}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className="language-btn"
            >
            🌍
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item
                    active={lang === "en"}
                    onClick={() => setLang("en")}
                >
                English
                </Dropdown.Item>

                <Dropdown.Item
                    active={lang === "es"}
                    onClick={() => setLang("es")}
                >
                Español
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};